let base = window._env_.VUE_APP_HOST

export function permissionhost (params) {
  if (params && params.host) {
    return `//${params.host}`
  } else {
    return base
  }
}



// WEBPACK FOOTER //
// ./src/views/permission-group/permission-config-host.js